import React from 'react';
import ActionIconButton from '../ActionIconButton';
import i18n from '../../translations/i18n';

import './SidebarMenu.scss';
import './SidebarMenuTitle.scss';
import './SidebarMenuContent.scss';

const tFixed = i18n.getFixedT(null, 'menu');
const noop = () => { };

export const Title = ({
    icon,
    title,
    onIconTitleClick,
}) => (
    <div className="sidebar-title-section">
        <ActionIconButton
            onClick={onIconTitleClick || noop}
            title={tFixed('closeSidebar')}
        >
            {!!icon && icon}
        </ActionIconButton>
        <div className="title">
            <label>{tFixed('menu')}</label>
            <label>{title}</label>
        </div>
    </div>
);

export const Content = ({ children }) => (
    <div className="sidebar-content-section">
        {children}
    </div>
);
